// Module
var code = `<button
  class="app-list-item-button"
  data-content-key="{{contentKey}}"
  data-event-type="appBtn"
  data-type="setApp"
>
  <p>{{contentName}}</p>
</button>
<button
  class="app-list-item-x"
  data-user-id="{{userId}}"
  data-event-type="appBtn"
  data-type="removeApp"
>
  x
</button>
`;
// Exports
module.exports = code;